(function () {
  const slideshow = () => {
    $(".slideshow-section").each(function () {
      if ($(this).hasClass("slider_started")) {
        return "";
      }
      $(this).addClass("slider_started");
      const id = $(this).attr("id");
      const box = $(this).find(".slideshow");
      const autoplay = box.data("autoplay");
      const stopAutoplay = box.data("stop-autoplay");
      const delay = box.data("delay") * 1000;
      const slideCount = box.data("count");
      const loop = slideCount == 1 ? false : true;

      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      } else {
        autoplayParm = {};
      }
      let swiperParms = {
        parallax: true,
        spaceBetween: 0,
        speed: box.data("speed") * 1000,
        loop: loop,
        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },
        pagination: {
          el: `#${id} .swiper-pagination`,
          clickable: true,
        },
        ...autoplayParm,
      };
      const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms);
      colorScheme(swiper);
      swiper.on("beforeTransitionStart", function () {
        colorScheme(this);
      });
      function colorScheme(context) {
        const activeIndex = context.activeIndex;
        const activeSlide = context.slides[activeIndex];
        const changeItems = [
          context.navigation.nextEl,
          context.navigation.prevEl,
          context.pagination.el,
        ];
        const colorScheme = $(activeSlide)
          .find(".slideshow-slide")
          .data("color-scheme");
        changeItems.forEach((item) => {
          $(item)
            .removeClass("color-background-1")
            .removeClass("color-background-4")
            .addClass(colorScheme);
        });
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    slideshow();
    document.addEventListener("shopify:section:load", function () {
      slideshow();
    });
  });
})();
